<template>
    <div>
        <div class="footer-up bg-green">
            <div class="container">
                <ul class="footer-up-menu">
                    <li>
                        <span class="subbar-icon subbar-icon-diplomat-search"></span>
                        <a class="link"
                           href="/business">{{$t('Решения для бизнеса')}}</a>
                    </li>
                    <li><span class="subbar-icon subbar-icon-tie"></span>
                        <a class="link"
                           href="/individuals">{{$t('Частным лицам')}}</a>
                    </li>
                    <li><span class="subbar-icon subbar-icon-money-dialog"></span>
                        <a class="link"
                           href="/fees">{{$t('Тарифы')}}</a></li>
                    <li><span class="subbar-icon subbar-icon-news"></span>
                        <a class="link"
                           href="/news">{{$t('Новости')}}</a>
                    </li>

                    <li><span class="subbar-icon subbar-icon-contacts"></span>
                        <a class="link"
                           href="/contacts">{{$t('Контакты')}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <footer class="footer">
            <div class="footer__top">
                <div class="container">
                    <ul class="footer__bar">
                        <li><a href="/">
                            <div class="text-left footer__logo">
                                <i class="capitalist-icon-capitalist-logo-headed"></i>
                            </div>
                        </a>

                        </li>
                        <li>

                            <ul class="social-row">
                                <li><a href="https://www.instagram.com/capitalist_cap/" target="_blank">
                                    <i class="social-icon capitalist-icon-instagram"></i>
                                </a></li>

                                <li><a href="https://www.facebook.com/capitalist.net/" target="_blank">
                                    <i class="social-icon capitalist-icon-social-facebook"></i>
                                </a></li>

                                <li><a href="https://vk.com/capitalist_net" target="_blank">
                                    <i class="social-icon capitalist-icon-social-vk"></i>
                                </a></li>

                                <li><a href="https://tele.click/Capitalist_net" target="_blank">
                                    <i class="social-icon capitalist-icon-telegram"></i>
                                </a></li>

                                <li><a href="https://www.linkedin.com/company/capitalist-inc/" target="_blank">
                                    <i class="social-icon capitalist-icon-linkedin-inverted"></i>
                                </a></li>
                                <!-- <li><i class="social-icon social-icon-telegram"></i></li> -->
                            </ul>

                          <div style="font-size: 28px; margin-top: 15px;">
                            <a href="https://ru.trustpilot.com/review/capitalist.net" target="_blank" title="Trustpilot"><span class="capitalist-icon-logo-trustpilot-bw"></span></a>
                          </div>
                        </li>
                        <li class="footer__top__right">
                            <div class="footer__top__right__links">
                                <ul style="list-style: disc;">
                                    <li><a href="/useragreement">{{$t('Пользовательское соглашение')}}</a></li>
                                    <li v-show="showPrivacyPolicyLink"><router-link to="/privacypolicy">{{$t('Политика прайваси')}}</router-link></li>
                                    <li><a href="/developers/api">{{$t('Для разработчиков')}}</a></li>
                                </ul>

                            </div>
                        </li>
                    </ul>

                    <hr/>
                </div>
            </div>
            <div class="footer__bottom">
                <div class="container">
                    <!-- <p><strong><a href="#">Prepaid Visa Agreement</a></strong> / <strong><a href="#">Prepaid Mastercard Agreement</a></strong></p> -->
                    <!--            <p>-->
                    <!--            <a href="#">API для разработчиков</a> / <a href="#">Пользовательское соглашение</a>-->
                    <!--            </p>-->
                    <ul>
                        <li>
                            <p>
                                &copy; <a href="http://capitalist.net">Capitalist.net</a>,
                                <span>{{copyYear}}</span>. {{$t('Все права защищены.')}}
                            </p>
                        </li>
                        <li>
                            <div class="trustwave-logo-fix">

                            </div>
                        </li>
                    </ul>

                    <br/>

                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
  name: 'CapGuestFooter',
  computed: {
    copyYear() {
      return `${new Date().getFullYear()}`;
    },
    showPrivacyPolicyLink() {
      return this.$i18n.locale == 'en';
    },
  },
};
</script>

<style scoped>

</style>

<i18n>
    {
    "en": {
    "Политика прайваси": "Privacy policy"
    }
    }
</i18n>
